import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Radio, Form, Input, message, Button, Upload, Modal, Slider } from "antd";
import Cropper from "react-easy-crop";

import { UploadOutlined, CloseOutlined} from "@ant-design/icons";
import axios from "../../../helper/axios";
import editIcon from "../../../assets/pencil.png";
import useJDStore from "../../../store/jd.store";
import memberstore from "../../../store/members.store";
import NuJobStore from "../../../store/nujobsdetails.store";

import "./profile.scss";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";
import useNuJobsStore from "../../../store/nujobs.store";


export default function NUJobsProfile() {
  const [isEditMode, setIsEditMode] = useState(false);
  const [formKey, setFormKey] = useState(1);
  const { value } = useParams();
  const [profilestatus, setProfileStatus] = useState("opentowork");
  const { nujobsUpdateProfile} = useNuJobsStore(); 

  const userDetails = JSON.parse(localStorage.getItem("nujobsUserDetails")) || {};
  const [logoFile, setLogoFile] = useState(null);
  const getImageSrc = (img) => {
    if (!img) return null;
    if (typeof img !== "string") return img;
    if (img.startsWith("data:")) return img;

    const sig = img.slice(0, 5);
    if (sig.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
    if (sig.startsWith("iVBOR")) return `data:image/png;base64,${img}`;
    if (sig.startsWith("R0lG")) return `data:image/gif;base64,${img}`;

    return `data:image/jpeg;base64,${img}`;
  };
  const [logoPreview, setLogoPreview] = useState(
    getImageSrc(userDetails?.profile_image) || null,
  );
  const [cropSource, setCropSource] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isCropModalOpen, setIsCropModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  //console.log("userDetails", userDetails.qhoid);

  useEffect(() => {}, []);

  const createImage = (source) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", reject);
      image.src = source;
    });

  const getCroppedImage = async (source, cropPixels, fileName, fileType) => {
    const image = await createImage(source);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    canvas.width = cropPixels.width;
    canvas.height = cropPixels.height;
    context.drawImage(
      image,
      cropPixels.x,
      cropPixels.y,
      cropPixels.width,
      cropPixels.height,
      0,
      0,
      cropPixels.width,
      cropPixels.height,
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Unable to crop image"));
          return;
        }
        resolve(new File([blob], fileName, { type: fileType || "image/jpeg" }));
      }, fileType || "image/jpeg");
    });
  };

  const getUploadedFileFromValue = (value) => {
    if (!value) return null;
    if (value instanceof File) return value;
    if (value?.originFileObj instanceof File) return value.originFileObj;
    if (
      Array.isArray(value?.fileList) &&
      value.fileList[0]?.originFileObj instanceof File
    ) {
      return value.fileList[0].originFileObj;
    }
    if (Array.isArray(value) && value[0]?.originFileObj instanceof File) {
      return value[0].originFileObj;
    }
    return null;
  };

  const buildProfileFormData = (values) => {
    const formData = new FormData();

    Object.entries(values).forEach(([key, val]) => {
      if (val === undefined || val === null) return;

      if (key === "profileImage") {
        const uploadedFile = logoFile || getUploadedFileFromValue(val);
        if (uploadedFile) {
          formData.append("profileImage", uploadedFile, uploadedFile.name);
        }
        return;
      }

      if (
        typeof val === "object" &&
        !(val instanceof File) &&
        !(val instanceof Blob)
      ) {
        formData.append(key, JSON.stringify(val));
      } else {
        formData.append(key, val);
      }
    });

    if (logoFile && !values?.profileImage) {
      formData.append("profileImage", logoFile, logoFile.name);
    }

    //console.log("built formdata entries", [...formData.entries()]);
    return formData;
  };

  const submitProfile = async (values, endpoint, method = "post") => {
    //console.log(values);

    const formData = buildProfileFormData(values);
    //console.log("formdata", formData);

  };

  const handleFormSubmit = async (values) => {
    try {
      //console.log("submitting the user update", values)
      const formData = buildProfileFormData(values);

      await nujobsUpdateProfile(formData);
      setIsEditMode(false);
      message.success("Profile created successfully");
    } catch (error) {
      // error message is already shown in submitProfile
    }
  };

  const handleLogoBeforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setCropSource(e.target.result);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setIsCropModalOpen(true);
    };
    reader.readAsDataURL(file);
    return false;
  };

  const handleCropComplete = (_, cropPixels) => {
    setCroppedAreaPixels(cropPixels);
  };

  const handleCropCancel = () => {
    setCropSource(null);
    setIsCropModalOpen(false);
    setZoom(1);
  };

  const handleCropApply = async () => {
    if (!cropSource || !croppedAreaPixels) return;

    try {
      const croppedFile = await getCroppedImage(
        cropSource,
        croppedAreaPixels,
        "profile-image.jpg",
        "image/jpeg",
      );
      const previewReader = new FileReader();
      previewReader.onload = (e) => setLogoPreview(e.target.result);
      previewReader.readAsDataURL(croppedFile);
      setLogoFile(croppedFile);
      setCropSource(null);
      setIsCropModalOpen(false);
    } catch (error) {
      message.error("Unable to crop image. Please try again.");
    }
  };

  const handleLogoRemove = () => {
    setLogoFile(null);
    setLogoPreview(getImageSrc(userDetails?.profile_image) || null);
    handleCropCancel();
  };

  const handleCancelEdit = () => {
    setLogoFile(null);
    setLogoPreview(getImageSrc(userDetails?.profile_image) || null);
    handleCropCancel();
    setIsEditMode(false);
  };

  const handleUpdateFormSubmit = async (values) => {
    try {
      const endpoint = "/profile/update"; // TODO: replace with your actual backend route
      await submitProfile(values, endpoint, "post");
      message.success("Profile updated successfully");
      setIsEditMode(false);
    } catch (error) {
      // error message is already shown in submitProfile
    }
  };

  
    const onChange = (e) => {      
        //setReqType(e.target.value)
        setProfileStatus(e.target.value)
      };


    var profileValues = {
            user_name: userDetails?.username,
            mobile: userDetails?.contact,
            email: userDetails?.email,
            city: userDetails?.city,
            country: userDetails?.country,
            pincode:userDetails?.pincode,
            sub_status: userDetails?.sub_status,
            sub_name: userDetails?.sub_name,
            sub_type: userDetails?.sub_type,
            sub_date: userDetails?.offered_CTC,
            sub_start_date: userDetails?.creation_date,
            sub_end_date: userDetails?.priority,
            creation_date: userDetails?.creationdate,
    };

    return (
        <div className="nujobsprofile-form-wrapper">
            <div className="header">


          {!isEditMode ? (
            <Button
              className="profile-edit-button"
              onClick={() => setIsEditMode(true)}
              type="primary"
            >
              <img src={editIcon} alt="Edit" width="14" height="14" />
            </Button>
          ) : (
              <Button className="profile-edit-button" onClick={handleCancelEdit}>
              <CloseOutlined /> Cancel
            </Button>
          )}                        
            </div>
            <Form
                key={formKey}
                className="profile-form"
                name="profile-form"
                justify="start"
                layout="vertical"
                autoComplete="off"
                onFinish={value ? handleFormSubmit : handleFormSubmit}
                initialValues={profileValues}
            >
        <div className="company-logo-wrapper">
          <Form.Item
            className="profile-field-item"
            label="My Profile Image"
            name="profileImage"
            valuePropName="fileList"
            getValueFromEvent={(e) => {
              if (Array.isArray(e)) return e;
              return e?.fileList || [];
            }}
          >
            <Upload
              accept="image/*"
              beforeUpload={handleLogoBeforeUpload}
              onRemove={handleLogoRemove}
              showUploadList={false}
              disabled={!isEditMode}
              multiple={false}
            >
              <div className="profile-logo-upload">
                {logoPreview ? (
                  <img
                    src={logoPreview}
                    alt="Profile Image"
                    className="company-logo-preview"
                    style={{ width: "200px", height: "200px" }}
                  />
                ) : (
                  <div className="upload-placeholder">
                    {isEditMode
                      ? "Click to upload Image"
                      : "No image uploaded"}
                  </div>
                )}
                {isEditMode && (
                  <Button icon={<UploadOutlined />} style={{ marginTop: 8 }}>
                    {logoPreview ? "Change Image" : "Upload Image"}
                  </Button>
                )}
              </div>
            </Upload>
          </Form.Item>
        </div>
                <div className="triple-input-wrapper">
                    <Form.Item
                        required={isEditMode}
                        className="profile-field-item"
                        label="User Name"
                        name="user_name"
                    >
                        <Input
                            disabled={!isEditMode}
                            required={isEditMode}
                            className="profile-input"
                        />
                    </Form.Item> 
                    <Form.Item
                        required={isEditMode}
                        className="profile-field-item"
                        label="Mobile Number"
                        name="mobile"
                    >
                        <Input
                            disabled={!isEditMode}
                            required={isEditMode}
                            className="profile-input"
                        />
                    </Form.Item>
                    <Form.Item                            
                            name="email"
                            className="profile-field-item"
                            label="Email ID (Can not Change)"
                        >
                            <Input
                                disabled={true}                                
                                className="profile-input"
                            />
                    </Form.Item>                                                          
                </div>
                        <div className="triple-input-wrapper">   
                            <Form.Item
                                className="profile-field-item"
                                label="City"
                                name="city"
                            >
                                <Input
                                    disabled={!isEditMode}
                                    className="profile-input"
                                />
                            </Form.Item>                                              
                            <Form.Item
                                    name="country"
                                    className="profile-field-item"
                                    label="Country"
                                >
                                    <Input     
                                        disabled={!isEditMode}          
                                        className="profile-input"
                                    />
                            </Form.Item>
                            <Form.Item
                                    required={isEditMode}
                                    name="pincode"
                                    className="profile-field-item"
                                    label="Pin Code"
            rules={[
              {
                required: isEditMode,
                message: "Pin code is required",
              },
              {
                pattern: /^[0-9]+$/,
                message: "Pin code must be numeric",
              },
            ]}
                                >
                                    <Input                                
                                        disabled={!isEditMode}
              inputMode="numeric"
                                        className="profile-input"
                                    />
                            </Form.Item>
                        </div>                     
                <div className="triple-input-wrapper">
                    <Form.Item
                            name="creation_date"
                            className="profile-field-item"
                            label="Profile Creation Date"
                        >
                            <Input
                                disabled={true}
                                className="profile-input"
                            />
                    </Form.Item>
                    <Form.Item
                            name="profilestatus"
                            className="profile-field-item"
                            label="Profile Status"
                        >
                            <Radio.Group
                                disabled={!isEditMode}
                                className="profile-field-item"
                                onChange={onChange}
                                defaultValue={"opentowork"}
                                required={true}
                            >
                                <Radio
                                    className="radio-option"
                                    value="opentowork"
                                >
                                    Open to Work
                                </Radio>                                
                                <Radio
                                    className="radio-option"
                                    value="notopentowork"
                                >
                                    Hide/Not Open to Work
                                </Radio>

                                <Radio
                                    className="radio-option"
                                    value="delete"
                                >
                                    Delete My Profile
                                </Radio>                                
                            </Radio.Group>
                    </Form.Item>                                    
                </div>
                <Button
                            style={{ width: "50%", height: "40px", fontWeight: "600" }}
                            type="primary"
                            disabled={!isEditMode || submitting}
                            loading={submitting}
                            htmlType="submit"
                        >
                             {
                                profilestatus=="delete"?
                                <>
                                  Delete My Profile
                                </>
                                :<>
                                  Update NuJobs Profile
                                </>
                             }
                            
                </Button>
                                 
            </Form>

            <Modal
              open={isCropModalOpen}
              title="Adjust profile image"
              onCancel={handleCropCancel}
              footer={[
                <Button key="cancel" onClick={handleCropCancel}>
                  Cancel
                </Button>,
                <Button key="apply" type="primary" onClick={handleCropApply}>
                  Apply crop
                </Button>,
              ]}
              centered
            >
              <div className="profile-image-cropper">
                <Cropper
                  image={cropSource}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={handleCropComplete}
                  cropShape="round"
                  showGrid={false}
                />
              </div>
              <div className="profile-image-zoom-control">
                <span>Zoom</span>
                <Slider
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={setZoom}
                />
              </div>
            </Modal>
            
            <NuJobsSignedInFooter/>                    
        </div>
    );
}
